<script lang="ts">
	import type { Pagename } from '$lib/services/urls/routesPagename';
	import type { ClassValue } from 'svelte/elements';
	import MichelinSwitch from '$lib/components/atoms/michelinSwitch/MichelinSwitch.svelte';
	import { track } from '$lib/services/tracking/googleAnalytics';
	import { getSearchParamsStore } from '$lib/services/urls/searchParams';
	import * as m from '$paraglide/messages';

	interface Props {
		pageContext: Extract<Pagename, 'homepage' | 'poi.filter'>;
		class?: ClassValue;
		onchange?: (isOnlyMichelin: boolean) => void;
	}

	const { pageContext, class: classes, onchange }: Props = $props();
	const searchParams = getSearchParamsStore();
	let isOnlyMichelin = $derived(!!(
		$searchParams?.filters?.MICHELIN_ACCOMMODATION
		&& $searchParams?.filters?.ONLY_MICHELIN_GUIDE_SELECTION
	));

	function updateSwitchState() {
		isOnlyMichelin = !isOnlyMichelin;

		track({
			action: 'michelin_selection_filter',
			payload: {
				action: 'selection',
				context: pageContext,
				michelin_selection: isOnlyMichelin ? 'true' : 'false',
			},
		});

		onchange?.(isOnlyMichelin);
	}
</script>

<div class={['bg-neutral-weakest p-2 rd-2 flex flex-col', classes]}>
	<MichelinSwitch
		text={m.poi_filters__only__michelin()}
		id="only-michelin-switch"
		checked={isOnlyMichelin}
		onchange={updateSwitchState}
	/>
</div>
